<template>
  <div class="app-container">
    <el-container class="header_container">
      <el-header>
        <h2>用户管理</h2>
      </el-header>
      <el-main>
        <el-table
          v-loading="loading"
          :data="list"
          border
          size="mini"
          fit
          highlight-current-row
          width="100%"
          height="72vh"
        >
          <af-table-column prop="name" label="姓名" />
          <af-table-column prop="roles" label="账号角色" />
          <af-table-column label="路由权限">
            <template slot-scope="scope">
              <el-select placeholder="查看用户权限" size="mini" filterable value>
                <el-option
                  v-for="(item, index) in scope.row.permissions.menu"
                  :key="index"
                  class="permission_tag"
                  :value="item.id"
                >{{ item.name }}</el-option>
              </el-select>
            </template>
          </af-table-column>
          <af-table-column label="功能权限">
            <template slot-scope="scope">
              <el-select placeholder="查看功能权限" size="mini" filterable value>
                <el-option
                  v-for="(item, index) in scope.row.permissions.api"
                  :key="index"
                  class="permission_tag"
                  :value="item.id"
                >{{ item.name }}</el-option>
              </el-select>
            </template>
          </af-table-column>
          <af-table-column prop="permission" label="可操作广告主">
            <template slot-scope="scope">
              <el-select placeholder="查看可操作性广告主" size="mini" filterable value>
                <el-option
                  v-for="(item, index) in scope.row.advertisers"
                  :key="index"
                  class="permission_tag"
                  :value="item.advertisers_id"
                >{{ item.advertiser_name }}</el-option>
              </el-select>
            </template>
          </af-table-column>
          <af-table-column prop="status" width="50px" label="状态">
            <template slot-scope="scope">{{ scope.row.status===1?'正常':'过期' }}</template>
          </af-table-column>
          <af-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="showEditBox(scope)">修改</el-button>
              <el-button type="primary" size="mini" @click="showEditAdvertiserBox(scope)">修改可操作广告主</el-button>
              <el-button type="warning" size="mini" @click="showResetBox(scope)">重置密码</el-button>
            </template>
          </af-table-column>
        </el-table>
        <el-pagination
          :page-size="meta.per_page"
          class="pagination"
          background
          size="mini"
          layout="total, prev, pager, next, jumper"
          :total="meta.total"
          @current-change="userCurrentChange"
        />
      </el-main>
    </el-container>
    <!-- 重置密码框  -->
    <el-dialog
      title="重置密码"
      :visible.sync="reset_password.show"
      width="30%"
      :before-close="closeResetBox"
      center
    >
      <div class="reset_password_main">
        <el-tag type="info">用户：{{ reset_password.name }}</el-tag>
        <el-input
          v-model="reset_password.password"
          size="mini"
          class="reset_password_input"
          placeholder="请输入新密码"
        />
        <el-input
          v-model="reset_password.confirm_password"
          size="mini"
          class="reset_password_input"
          placeholder="请重复输入新密码"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="resetCancel">取 消</el-button>
        <el-button size="mini" type="primary" @click="resetPassword">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改框  -->
    <el-dialog title="修改" :visible.sync="edit.show" width="30%" :before-close="closeEditBox" center>
      <edit-box
        v-if="edit.show"
        :data="edit.data"
        @config="editdvertiseConfigCallback"
        @cancel="closeEditBox"
      />
    </el-dialog>

    <!-- 修改广告主  -->
    <el-dialog
      title="修改绑定广告主"
      :visible.sync="edit_advertiser.show"
      width="50%"
      :before-close="closeEditBox"
      center
    >
      <edit-advertiser-box
        v-if="edit_advertiser.show"
        :data="edit_advertiser.data"
        @config="editConfigCallback"
        @cancel="closeEditAdvertiserBox"
      />
    </el-dialog>
  </div>
</template>
<script>
// 请求用户列表的接口
import UserResource from '@/api/user';
const userResource = new UserResource();
// 修改框
import editBox from '@/views/system/user-manage/function/edit';
import editAdvertiserBox from '@/views/system/user-manage/function/edit-advertiser';

export default {
  name: 'UserManage',
  components: {
    'edit-box': editBox,
    'edit-advertiser-box': editAdvertiserBox,
  },
  data() {
    return {
      loading: true,
      list: [],
      meta: {
        current_page: 1,
        per_page: 15,
        total: 55,
      },
      query: {
        page: 1,
        limit: 15,
        keyword: '',
        roles: [],
      },
      reset_password: {
        show: false,
        name: '',
        id: null,
        password: null,
        confirm_password: null,
      },
      edit: {
        show: false,
        data: {},
      },
      edit_advertiser: {
        show: false,
        data: {},
      },
      add_role: {
        name: '',
      },
    };
  },

  // 生命周期-创建
  created() {
    this.getUserList();
  },

  methods: {
    // 获取角色列表
    async getUserList() {
      this.loading = true;
      const { data, meta } = await userResource.getUserList(this.query);
      this.list = data;
      // 把per_page先int化，不然vue会报不够规范的错误
      meta.per_page = parseInt(meta.per_page);
      this.meta = meta;
      this.loading = false;
    },

    // 分页组件方法
    userCurrentChange(val) {
      this.query.page = val;
      this.getUserList();
    },

    // 显示重置密码框
    showResetBox(scope) {
      this.reset_password.name = scope.row.name;
      this.reset_password.id = scope.row.id;
      this.reset_password.show = true;
    },

    // 关闭重置密码框
    closeResetBox(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
          this.emptyResetPasswordData();
        })
        .catch(_ => {});
    },

    // 重置密码
    async resetPassword() {
      const { password, confirm_password } = this.reset_password;
      if (password === '' || password === null) {
        this.$message({
          message: '请输入密码',
          type: 'warning',
        });
        return;
      }
      if (
        confirm_password === '' ||
        confirm_password === null ||
        confirm_password !== password
      ) {
        this.$message({
          message: '重复密码必须与密码保持一致',
          type: 'warning',
        });
        return;
      }
      if (password.toString().length < 6) {
        this.$message({
          message: '密码过于简陋，须为6位字符以上',
          type: 'warning',
        });
        return;
      }
      await userResource
        .resetPassword(this.reset_password)
        .then(response => {
          this.$message({
            message: '密码重置成功',
            type: 'success',
          });
          this.emptyResetPasswordData();
        })
        .catch(error => {
          console.log(error);
          this.reset_password.password = null;
          this.reset_password.confirm_password = null;
        });
    },
    // 取消重置密码
    resetCancel() {
      this.emptyResetPasswordData();
    },

    // 清空 重置密码的数据
    emptyResetPasswordData() {
      this.reset_password = {
        show: false,
        name: '',
        id: null,
        password: null,
        confirm_password: null,
      };
    },

    // 显示编辑框
    showEditBox(scope) {
      this.edit.data = scope.row;
      this.edit.show = true;
    },

    editConfigCallback() {
      this.edit_advertiser.show = false;
      this.getUserList();
    },

    // 关闭编辑框
    closeEditBox(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.edit.show = false;
          done();
        })
        .catch(_ => {});
    },

    // 显示更改可操作性广告主框
    showEditAdvertiserBox(data) {
      this.edit_advertiser.data = data.row;
      this.edit_advertiser.show = true;
    },

    editdvertiseConfigCallback() {},

    // 关闭编辑可操作性广告主框
    closeEditAdvertiserBox(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.edit_advertiser.show = false;
          done();
        })
        .catch(_ => {});
    },

    // 更新select
    changeSelect() {
      this.$forceUpdate();
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.permission_tag {
  margin: 2px;
}
.reset_password_main {
  .reset_password_input {
    margin-top: 5px;
  }
}
.edit_main {
  .edit_input {
    width: 300px;
  }
}
.add_role {
  width: 100%;
}
.el-header {
  height: 40px !important;
  line-height: 40px !important;
  padding: 0 10px;
}
.el-main {
  padding: 10px;
}
.header_container {
  background: #eef0f3;
  border-radius: 5px;
  .el-header {
    border-bottom: 1px solid #fff;
    h2 {
      margin: 0;
      height: 40px;
      line-height: 40px;
    }
  }
}

.pagination {
  margin-top: 5px;
}
</style>
